import { ManageElement } from "./ManageElement";
import { BullpenWeightStore } from "stores/BullpenWeightStore";

export class BullpenWeight extends ManageElement {
  static _store: BullpenWeightStore;
}
